import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { CustomFieldService } from '@app/core';
import { CustomField } from '@app/shared';


@Injectable({
    providedIn: 'root'
})
export class CustomFieldResolverService {

    constructor(
        private customFieldService: CustomFieldService,
        private router: Router
    ) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<CustomField> {
        const id = route.paramMap.get('id');

        if (id === null) {
            return of(new CustomField());
        }

        return this.customFieldService.get(+id).pipe(
            map(field => {
                if (field) {
                    return field;
                }
                this.router.navigate(['/admin/custom-field-list']);
                return null;
            })
        );
    }
}
